import { Chip } from '@mui/joy';
import { TaskStatus, TASK_STATUS_LABELS } from '@/types/project';

const STATUS_COLORS: Record<TaskStatus, 'neutral' | 'primary' | 'success' | 'danger'> = {
  not_started: 'neutral',
  in_progress: 'primary',
  completed: 'success',
  blocked: 'danger',
};

export default function TaskStatusChip({ status }: { status: TaskStatus }) {
  return (
    <Chip size="sm" variant="soft" color={STATUS_COLORS[status]}>
      {TASK_STATUS_LABELS[status]}
    </Chip>
  );
}
